var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSchedule = function SvgSchedule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd8f60c2-b756-4c2d-aeec-9a731f44f4b0",
    "data-name": "Layer 10",
    viewBox: "0 0 96.23 106.34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 19.89,
    y: 58.42,
    width: 6.99,
    height: 6.99
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 36.46,
    y: 58.42,
    width: 6.99,
    height: 6.99
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 52.81,
    y: 58.42,
    width: 6.99,
    height: 6.99
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 69.35,
    y: 58.42,
    width: 6.99,
    height: 6.99
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 19.89,
    y: 76.55,
    width: 6.99,
    height: 6.99
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 36.46,
    y: 76.55,
    width: 6.99,
    height: 6.99
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 52.81,
    y: 76.55,
    width: 6.99,
    height: 6.99
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    x: 69.35,
    y: 76.55,
    width: 6.99,
    height: 6.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f8ac62db-a531-46c0-bf42-e2fe89b7b0aa",
    d: "M124,11.57h-6.48V9.3a7.84,7.84,0,1,0-15.67,0v2.27H67.93V9.3a7.83,7.83,0,1,0-15.66,0v2.27H45.79a9,9,0,0,0-9,9V98.77a9,9,0,0,0,9,9H124a9,9,0,0,0,9-9V20.6A9,9,0,0,0,124,11.57ZM105.45,9.3a4.2,4.2,0,1,1,8.39,0V23.24a4.2,4.2,0,1,1-8.39,0Zm-49.54,0a4.19,4.19,0,1,1,8.38,0V23.24a4.19,4.19,0,1,1-8.38,0Zm73.44,89.47a5.4,5.4,0,0,1-5.39,5.39H45.79a5.4,5.4,0,0,1-5.39-5.39V43.58h88.95Zm0-58.82H40.4V20.6a5.4,5.4,0,0,1,5.39-5.4h6.48v8a7.83,7.83,0,1,0,15.66,0v-8h33.88v8a7.84,7.84,0,1,0,15.67,0v-8H124a5.4,5.4,0,0,1,5.39,5.4Z",
    transform: "translate(-36.76 -1.46)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSchedule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule.25026ea1.svg";
export { ForwardRef as ReactComponent };